import React from 'react'
import './Home.css'

function Home() {
  return <div className="home">Home</div>
}

export default Home
